<template>
    <div class="padding-10">
      <Toolbar></Toolbar>
      <FilterBar></FilterBar>
      <Table></Table>
    </div>
  </template>
  
  <script>
  import Toolbar from "../components/estimate/Toolbar";
  import FilterBar from "../components/estimate/Filter";
  import Table from "../components/estimate/Table.vue";
  export default {
    components: {
      Toolbar,
      FilterBar,
      Table,
    },
    mounted() {},
  };
  </script>
  
  <style></style>
  